import _ from 'lodash'
function createOperationRender(component, row, actionsAndPermissions) {
  const h = component.$createElement
  return Object.keys(actionsAndPermissions).map((key) => {
    return h(
      'el-button',
      {
        props: {
          type: 'text',
          size: 'mini'
        },
        on: {
          click: () => {
            component[key](row)
          }
        }
      },
      actionsAndPermissions[key]
    )
  })
}
function optionsToText(options) {
  return options.reduce((result, { label, value }) => {
    result[value] = label
    return result
  }, {})
}
function optionsToTextColor(options) {
  return options.reduce((result, { value, color }) => {
    result[value] = color
    return result
  }, {})
}
function parseChartObjectToLine(arrObj, xName = 'xData', yName = 'yData') {
  let x = []
  let y = []
  ;(arrObj || []).forEach((item) => {
    x.push(item[xName])
    y.push(item[yName])
  })
  return { x, y }
}
function toLocaleString(number) {
  return number.toLocaleString('en-IN', { minimumFractionDigits: 2 })
}
function difference(object, base) {
  function changes(object, base) {
    return _.transform(object, function (result, value, key) {
      if (!_.isEqual(value, base[key])) {
        result[key] =
          _.isObject(value) && _.isObject(base[key]) ? changes(value, base[key]) : value
      }
    })
  }
  return changes(object, base)
}
const orderStatuaOptions = [
  {
    // label: '使用中',
    label: '启用中',
    value: 0,
    color: '#52C41A'
  },
  {
    label: '已结束',
    value: 1,
    color: '#000040'
  },
  {
    label: '暂停中',
    value: 2,
    color: '#F5222D'
  },
  {
    label: '待确认结算',
    value: 3,
    color: '#F5222D'
  },
  {
    label: '已到期',
    value: 4,
    color: '#000040'
  },
  {
    label: '已删除',
    value: -1,
    color: '#000'
  }
]
// 计划单相关
const scheduleStatusOptions = [
  {
    label: '草稿',
    value: 1,
    color: '#9e9a9a'
  },
  {
    label: '待审核',
    value: 2,
    color: '#FF8B00'
  },
  {
    label: '待投放',
    value: 3,
    color: '#000'
  },
  {
    label: '投放中',
    value: 4,
    color: '#1890ff'
  },
  {
    label: '已下线',
    value: 5,
    color: '#00000040'
  },
  {
    label: '已拒绝',
    value: 6,
    color: '#000'
  },
  {
    label: '已完成',
    value: 7
  },
  // {
  //   label: '超时未完成',
  //   value: 8
  // },
  {
    label: '暂停',
    value: 9,
    color: '#F5222D'
  },
  // {
  //   label: '预算不足',
  //   value: 10
  // },
  {
    label: '结算中',
    value: 11,
    color: '#d81010'
  },
  {
    label: '已删除',
    value: -1,
    color: '#000'
  }
]
const trafficType = [
  {
    label: '不限量',
    value: 1
  },
  {
    label: '总共投',
    value: 2
  },
  // {
  //   label: '按天投',
  //   value: 3,
  // },
  {
    label: '分天投',
    value: 4
  }
]
const saleType = [
  {
    label: '正常投放',
    value: 1
  },
  {
    label: '剩余流量',
    value: 2
  },
  {
    label: '测试投放',
    value: 4
  }
]
const supportModeType = [
  {
    label: '保价保量(PDB)',
    value: 0
  },
  {
    label: '保价不保量(PD)',
    value: 1
  },
  {
    label: '保价全量(CPDB)',
    value: 2
  }
]
const planType = [
  {
    label: '展示量合约',
    value: 0
  },
  {
    label: '程序化采买',
    value: 1
  }
]
const trafficSpeedType = [
  {
    label: '匀速',
    value: 2
  },
  {
    label: '快速',
    value: 1
  },
  {
    label: '智能',
    value: 3
  }
]
const SettlementType = [
  {
    label: '无',
    value: 0
  },
  {
    label: '曝光监测',
    value: 1
  },
  {
    label: '点击监测',
    value: 2
  },
  {
    label: '起播监测',
    value: 3
  },
  {
    label: '中点监测',
    value: 4
  },
  {
    label: '结束监测',
    value: 5
  }
]
const materialStatusOptions = [
  {
    label: '草稿',
    value: 0,
    color: '#9e9a9a'
  },
  {
    label: '待审核',
    value: 1,
    color: '#FF8B00'
  },
  {
    label: '待测试',
    value: 2,
    color: '#70b603'
  },
  {
    label: '审核不通过',
    value: 3,
    color: '#d9001b'
  },
  {
    label: '已测试',
    value: 4,
    color: '#70b603'
  },
  {
    label: '测试不通过',
    value: 5,
    color: '#d9001b'
  },
  {
    label: '已删除',
    value: -1,
    color: '#000'
  }
]
const financialTradOptions = [
  {
    value: 0,
    label: '充值'
  },
  {
    value: 1,
    label: '退款'
  },
  {
    value: 2,
    label: '结算'
  },
  {
    value: 3,
    label: '解冻'
  },
  {
    value: 4,
    label: '冻结'
  }
]
const financialCreditOptions = [
  {
    value: 0,
    label: '固定额度'
  },
  {
    value: 1,
    label: '临时额度'
  }
]
const companyNature = [
  {
    value: 0,
    label: '企业'
  },
  {
    value: 1,
    label: '个体账户'
  },
  {
    value: 2,
    label: '政府组织机构/事业单位'
  },
  {
    value: 3,
    label: '港澳台'
  },
  {
    value: 4,
    label: '其他机构'
  },
  {
    value: 5,
    label: '海外'
  }
]
const licenseType = [
  {
    value: 0,
    label: '组织机构代码代号'
  },
  {
    value: 1,
    label: '企业营业执照统一社会信用代码'
  },
  {
    value: 2,
    label: '政府组织机构/事业单位'
  },
  {
    value: 3,
    label: '企业营业执照注册号'
  }
]
const operateType = [
  {
    value: 0,
    label: '新增'
  },
  {
    value: 1,
    label: '修改'
  },
  {
    value: 2,
    label: '变更状态'
  },
  {
    value: 3,
    label: '推送媒体方素材'
  },
  {
    value: 4,
    label: '审核媒体方素材'
  },
  {
    value: 5,
    label: '推送牌照方素材'
  },
  {
    value: 6,
    label: '审核牌照方素材'
  }
]
const frequencyText = {
  1: '否',
  2: '整日限投',
  3: '投放周限投',
  4: '投放月限投',
  5: '整单限投',
  6: '自然周限投',
  7: '自然月限投'
}
const channelStatusText = {
  0: '待审核',
  1: '已审核',
  2: '已拒绝'
}
const dmpMatchText = {
  0: '全部匹配',
  1: '任意匹配',
  2: '排除',
}
const crowdMatchText = {
  0: '定向',
  1: '任意匹配',
  2: '排除',
}
const billTypeText = {
  1: 'CPM',
  2: 'CPC',
  3: 'CPD'
}
const orderStatisText = optionsToText(orderStatuaOptions)
const orderStatusTextColor = optionsToTextColor(orderStatuaOptions)
const shceduleStatusText = optionsToText(scheduleStatusOptions)
const shceduleStatusTextColor = optionsToTextColor(scheduleStatusOptions)
const materialStatisText = optionsToText(materialStatusOptions)
const materialSataisTextColor = optionsToTextColor(materialStatusOptions)
const financialTradText = optionsToText(financialTradOptions)
const financialCreditText = optionsToText(financialCreditOptions)
const companyNatureText = optionsToText(companyNature)
const licenseTypeText = optionsToText(licenseType)
const trafficTypeText = optionsToText(trafficType)
const SettlementTypeText = optionsToText(SettlementType)
const operateTypeText = optionsToText(operateType)
// 位置类型
const locationTypeText = {
  0: '全屏',
  1: '上左',
  2: '上中',
  3: '上右',
  4: '中左',
  5: '居中',
  6: '中右',
  7: '下左',
  8: '下中',
  9: '下右',
  10: '自定义'
}
const effectList = [
  { label: '0', value: '无' },
  { label: 'effect1', value: '从小变大' },
  { label: 'effect2', value: '移动飘过' },
  { label: 'effect4', value: '从上到下' },
  { label: 'effect5', value: '从下到上' }
]
// 动画效果
const effectText = {
  0: '无',
  effect1: '从小变大',
  effect2: '移动飘过',
  effect4: '从上到下',
  effect5: '从下到上'
}
const saleTypeText = optionsToText(saleType)
const supportModeTypeText = optionsToText(supportModeType)
const planTypeText = optionsToText(planType)
const trafficSpeedTypeText = optionsToText(trafficSpeedType)
const basicLineExtend = {
  tooltip: {
    confine: true
  },
  series: {
    symbol: 'circle',
    showSymbol: true,
    symbolSize: 2,
    smooth: false,
    itemStyle: {
      normal: {
        color: '#FF8B00', // 拐点颜色
        borderColor: '#FF8B00' // 拐点边框颜色
      },
      emphasis: {
        color: '#FF8B00' // hover拐点颜色定义
      }
    }
  },
  grid: {
    left: '0',
    right: '0',
    top: '10px',
    bottom: '0'
  },
  xAxis: {
    axisLine: {
      show: true,
      lineStyle: {
        color: '#999999',
        type: 'solid'
      }
    },
    axisTick: {
      show: false
    }
  },
  yAxis: {
    splitLine: {
      lineStyle: { type: 'dashed' }
    }
  }
  // color: ['#FF8B00', '#FCCA03', '#B1FC03', '#35FC03', '#FC0335', '#FD783F', '#FEA37C', '#03FC4E', '#FC03B1', '#7CD7FE', '#3FC4FD', '#03FCCA', '#CA03FC', '#4E03FC', '#0335FC', '#03B1FC']
}

const voiceAdPositions = {
  space1: '语音形象',
  space2: '语音挂件',
  space3: '全局引导',
  space4: '半屏卡片',
  space5: '全屏卡片'
}

const transcodeStatusOptions = [
  { label: '已完成', value: 0 },
  { label: '转码中', value: 1 },
  { label: '转码失败', value: 2 }
]

const transcodeStatusText = optionsToText(transcodeStatusOptions)

export default {
  transcodeStatusOptions,
  transcodeStatusText,
  createOperationRender,
  orderStatuaOptions,
  scheduleStatusOptions,
  materialStatusOptions,
  orderStatisText,
  orderStatusTextColor,
  shceduleStatusText,
  shceduleStatusTextColor,
  materialStatisText,
  materialSataisTextColor,
  parseChartObjectToLine,
  basicLineExtend,
  financialTradOptions,
  financialTradText,
  financialCreditOptions,
  financialCreditText,
  toLocaleString,
  companyNature,
  companyNatureText,
  licenseType,
  licenseTypeText,
  difference,
  trafficTypeText,
  locationTypeText,
  saleTypeText,
  supportModeTypeText,
  planTypeText,
  trafficSpeedTypeText,
  SettlementTypeText,
  operateTypeText,
  effectList,
  effectText,
  frequencyText,
  channelStatusText,
  dmpMatchText,
  crowdMatchText,
  billTypeText,
  voiceAdPositions
}
